module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.getIsShowingSomethingWentWrongPopup) ? _c('div', {
    staticClass: "background somethingWentWrongPopup d-flex flex-column align-items-center justify-content-center",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "popup radius-normal"
  }, [_c('div', {
    staticClass: "text-center fs-large darker bold pt-4 pb-2"
  }, [_vm._v("\n            Looks like something didn't go as expected, please contact our support team.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center p-4"
  }, [_c('button', {
    staticClass: "btn tertiary mr-2",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn blue",
    on: {
      "click": _vm.pressOk
    }
  }, [_c('i', {
    staticClass: "fas fa-comment-alt"
  }), _vm._v(" Contact us")])])])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1c4ce134", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c4ce134"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/other/SomethingWentWrong.vue
// module id = 2490
// module chunks = 0